import { useFetchEpisodeOverview } from 'client/hooks/episodes/useFetchEpisodeOverview';
import { useFetchPodcastMetadata } from 'client/hooks/podcast/usePodcastMetadata';
import { useFetchSpanStatus } from 'client/hooks/span/useSpanStatus';
import { useParams } from 'react-router-dom';

/**
 * enable waveform ad insertion if:
 * - is studios creator
 *   OR
 * - is SPAN activated and episode is a video podcast
 */
function useWaveformAdInsertionEnabled() {
  const { data = {} } = useFetchPodcastMetadata();
  const { isStudioCreator } = data;

  // activated span and episode is a video episode
  const { podcastEpisodeId: webEpisodeId } = useParams<{
    podcastEpisodeId: string;
  }>();
  const { episodeOverviewData } = useFetchEpisodeOverview({
    webEpisodeId,
  });
  const isVideoEpisode = Boolean(episodeOverviewData?.videoPodcastingEpisode);
  const { spanStatusData } = useFetchSpanStatus();
  const isSPANActivated =
    spanStatusData?.spanActivationLifeCycleState === 'activated';

  const isWaveformAdInsertionEnabled =
    isStudioCreator || (isVideoEpisode && isSPANActivated);

  return {
    isWaveformAdInsertionEnabled,
  };
}

export { useWaveformAdInsertionEnabled };
